import DigestTabState from 'analyses/DigestTabState';
import {SingletonCollection} from 'util/backbone-extensions';

class Digests extends SingletonCollection<DigestTabState> {
  override model = DigestTabState;
}

export default Digests;
